import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/sahCategories';

import { SahCategory } from '../models';

const initialState: CommonState<SahCategory> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<SahCategory>, SahCategory>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
